import { useCallback, useEffect, useState } from 'react';
import {
    getEnabledBuildingTypes,
    getLegacyBuildingTypes,
    setEnabledBuildingTypes,
} from '../../api/enabledBuildingTypesApi';
import { BuildingType } from '../../types/BuildingTypeEnums';

export interface EnabledBuildingTypesSettings {
    loading: boolean;
    /** The saved set; null when the instance has none (absent node = every type off). */
    saved: BuildingType[] | null;
    /** The saved set, or for an unconfigured instance the legacy node's enabled types. */
    initial: BuildingType[];
    save: (types: BuildingType[]) => Promise<void>;
}

/** Instansinställningar → Byggnadstyper: load the set, pre-fill an unconfigured instance, save. */
export function useEnabledBuildingTypesSettings(): EnabledBuildingTypesSettings {
    const [loading, setLoading] = useState(true);
    const [saved, setSaved] = useState<BuildingType[] | null>(null);
    const [initial, setInitial] = useState<BuildingType[]>([]);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const enabled = await getEnabledBuildingTypes();
            const prefill = enabled ?? (await getLegacyBuildingTypes()) ?? [];
            if (cancelled) return;
            setSaved(enabled);
            setInitial(prefill);
            setLoading(false);
        })();
        return () => { cancelled = true; };
    }, []);

    const save = useCallback(async (types: BuildingType[]) => {
        await setEnabledBuildingTypes(types);
        const stored = await getEnabledBuildingTypes();
        setSaved(stored);
        setInitial(stored ?? []);
    }, []);

    return { loading, saved, initial, save };
}
